import * as React from 'react';
import { useEnvironment, useTranslation } from '@wix/yoshi-flow-editor';

import { st, classes } from './FacetsEmptyMessage.st.css';

interface IFacetsEmptyMessageProps {
  onFacetsFilterReset(): void;
}

export const FacetsEmptyMessage: React.FC<IFacetsEmptyMessageProps> = ({
  onFacetsFilterReset,
}) => {
  const { isMobile } = useEnvironment();
  const { t } = useTranslation();

  return (
    <div className={st(classes.root, { mobileView: isMobile })}>
      <p className={classes.message}>
        {t('searchResults.products.facets.noResultsFound.message')}
      </p>
      <p className={classes.resetContainer}>
        <button
          data-hook="no-results-reset-button"
          className={classes.resetButton}
          onClick={() => onFacetsFilterReset()}
        >
          {t('searchResults.products.facets.noResultsFound.resetButton.label')}
        </button>
      </p>
    </div>
  );
};
